export enum USER_TYPE {
	USER = 'user',
	ORGANIZATION = 'organization',
	ADMIN = 'admin',
}
export enum LOT_STATUS {
	ACTIVE = 'Active',
	CLOSED = 'Closed',
}


